export default "__VITE_ASSET__CCYzKsW3__"